module.exports = __webpack_public_path__ + "f74af862b60925c2462cf0df66c27a93.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/lankenau06.jpg
// module id = 521
// module chunks = 0